__turbopack_context__.v({
  "className": "caveat_5a38b272-module__GpJJJa__className",
});
